/**
 * 「导出 PDF」= 把一份自包含 HTML 在新标签页打开并自动弹出浏览器打印
 * 对话框,老师选「另存为 PDF」。没有服务端 HTML→PDF 转换器(reportlab
 * 画不了 SVG/MathML,而这两样正是作业单/试卷里最要紧的),浏览器自己的
 * 打印引擎反而是最忠实的渲染器。
 *
 * 安全:文件可能是老师上传的任意 HTML。预览时它跑在 sandbox iframe
 * 里,导出时却要以本站 origin 打开(同源 blob),所以先把脚本、事件属性、
 * javascript: 链接、嵌入框架全部剥掉,只留静态内容,再注入我们自己的
 * 打印条和自动打印脚本。
 */

const STRIP_TAGS = /<\s*(script|iframe|object|embed|frame|frameset)\b[\s\S]*?(<\s*\/\s*\1\s*>|\/>)/gi;
const STRIP_SELF_CLOSING = /<\s*(script|iframe|object|embed|frame)\b[^>]*>/gi;
const EVENT_ATTR = /\s+on[a-z]+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi;
const JS_URL = /\s+(href|src|action|formaction)\s*=\s*("\s*javascript:[^"]*"|'\s*javascript:[^']*')/gi;

export function stripActiveContent(html: string): string {
  return html
    .replace(STRIP_TAGS, "")
    .replace(STRIP_SELF_CLOSING, "")
    .replace(EVENT_ATTR, "")
    .replace(JS_URL, "");
}

function esc(s: string): string {
  return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}

/** 注入打印条(屏幕可见、打印隐藏)+ 自动 print()。 */
export function withPrintChrome(html: string, labels: { print: string; hint: string; title?: string }): string {
  const bar = `<div class="__pdfbar" style="position:sticky;top:0;z-index:2147483647;display:flex;align-items:center;gap:12px;padding:10px 16px;background:#1f2937;color:#fff;font:13px system-ui,sans-serif">
<button onclick="window.print()" style="font:inherit;padding:6px 14px;border:0;border-radius:6px;background:#0ea5e9;color:#fff;cursor:pointer">${esc(labels.print)}</button>
<span style="opacity:.85">${esc(labels.hint)}</span></div>`;
  const head = `<style>@media print{.__pdfbar{display:none!important}}</style>${labels.title ? `<title>${esc(labels.title)}</title>` : ""}`;
  const script = `<script>window.addEventListener("load",function(){setTimeout(function(){window.print()},400)});</script>`;
  let out = stripActiveContent(html);
  if (/<head[^>]*>/i.test(out)) out = out.replace(/<head[^>]*>/i, (m) => m + head);
  else out = head + out;
  if (/<body[^>]*>/i.test(out)) out = out.replace(/<body[^>]*>/i, (m) => m + bar);
  else out = bar + out;
  if (/<\/body>/i.test(out)) out = out.replace(/<\/body>/i, script + "</body>");
  else out += script;
  return out;
}

/** 同源 blob 直接开新标签页(不加 noopener,见 window-open-noopener 的坑)。 */
export function openHtmlForPdf(html: string, labels: { print: string; hint: string; title?: string }): void {
  const url = URL.createObjectURL(new Blob([withPrintChrome(html, labels)], { type: "text/html" }));
  window.open(url, "_blank");
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
